  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.lp-buybox').forEach((section) => {
      initLpBuybox(section);
    });
  });

  function initLpBuybox(section) {
    const addToCartButton = section.querySelector(
      'button[type="submit"][name="add"]'
    );

    initLpGallery(section);
    syncAddToCartState(section, addToCartButton);
    customizeSealSubscriptions(section);

    section.addEventListener('click', (event) => {
      const flavourCard = event.target.closest('.lp-buybox__flavour');

      if (!flavourCard || !section.contains(flavourCard)) return;

      const quantityInput = flavourCard.querySelector('.quantity__input');

      if (!quantityInput) return;

      const clickedQuantityControl = event.target.closest('quantity-input');

      if (!clickedQuantityControl) {
        const nextQuantity =
          parseInt(quantityInput.value, 10) > 0 ? 0 : 1;

        quantityInput.value = nextQuantity;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      window.setTimeout(() => {
        syncFlavourCardState(flavourCard);
        syncAddToCartState(section, addToCartButton);
      }, 20);
    });

    section.addEventListener('change', (event) => {
      if (!event.target.matches('.lp-buybox__flavour .quantity__input')) return;

      const flavourCard = event.target.closest('.lp-buybox__flavour');

      syncFlavourCardState(flavourCard);
      syncAddToCartState(section, addToCartButton);
    });

    section.addEventListener('input', (event) => {
      if (!event.target.matches('.lp-buybox__flavour .quantity__input')) return;

      const flavourCard = event.target.closest('.lp-buybox__flavour');

      syncFlavourCardState(flavourCard);
      syncAddToCartState(section, addToCartButton);
    });

    section.addEventListener('click', (event) => {
    const pricingOption = event.target.closest(
      '.sls-option-container'
    );

    if (!pricingOption || !section.contains(pricingOption)) return;

    window.setTimeout(() => {
      syncAddToCartState(section, addToCartButton);
    }, 30);
  });

  const sealObserver = new MutationObserver(() => {
    customizeSealSubscriptions(section);
    syncAddToCartState(section, addToCartButton);
  });

    sealObserver.observe(section, {
      childList: true,
      subtree: true
    });
  }

  function initLpGallery(section) {
    const thumbnails = Array.from(
      section.querySelectorAll('[data-lp-gallery-thumbnail]')
    );

    if (!thumbnails.length) return;

    const mobileMainImage = section.querySelector(
      '.lp-buybox__mobile-main-image'
    );

    function selectThumbnail(thumbnail) {
      thumbnails.forEach((item) => {
        const isActive = item === thumbnail;

        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      const desktopImage = thumbnail.dataset.lpImageFull;
      const mobileImage = thumbnail.dataset.lpImageMobile || desktopImage;

      if (desktopImage) {
        section.style.setProperty(
          '--lp-buybox-bg-image',
          `url("${desktopImage}")`
        );
      }

      if (mobileMainImage && mobileImage) {
        mobileMainImage.src = mobileImage;
        mobileMainImage.removeAttribute('srcset');
      }
    }

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        selectThumbnail(thumbnail);
      });
    });

    selectThumbnail(
      thumbnails.find((thumbnail) =>
        thumbnail.classList.contains('is-active')
      ) || thumbnails[0]
    );
  }

  function syncFlavourCardState(flavourCard) {
    if (!flavourCard) return;

    const quantityInput = flavourCard.querySelector('.quantity__input');
    const quantity = parseInt(quantityInput?.value, 10) || 0;
    const isSelected = quantity > 0;

    flavourCard.classList.toggle('is-selected', isSelected);
    flavourCard.classList.toggle('option-selected', isSelected);
  }


  function getLpSelectedQuantity(section) {
    return Array.from(
      section.querySelectorAll('.lp-buybox__flavour .quantity__input')
    ).reduce(
      (total, input) => total + (parseInt(input.value, 10) || 0),
      0
    );
  }

  function getLpActivePlan(section) {
    const activeOption = section.querySelector(
      '.sls-option-container.sls-active'
    );

    if (!activeOption) return null;

  if (activeOption.classList.contains('lp-buybox__plan--90-day')) {
    return {
      type: '90-day',
      label: '90 Day Supply',
      minimum: 6,
      unitPrice: 70,
      monthlyDivisor: 3
    };
  }

  if (activeOption.classList.contains('lp-buybox__plan--30-day')) {
    return {
      type: '30-day',
      label: '30 Day Supply',
      minimum: 2,
      unitPrice: 75,
      monthlyDivisor: 1
    };
  }

    if (activeOption.classList.contains('lp-buybox__plan--one-time')) {
      return {
        type: 'one-time',
        label: 'One Time Purchase',
        minimum: 1
      };
    }

    return null;
  }

  function updateLpText(element, nextText) {
    if (!element || element.textContent === nextText) return;

    element.textContent = nextText;
  }

  function renderLpPlanProgress(section, activePlan, selectedQuantity) {
    const progress = section.querySelector('[data-lp-plan-progress]');
    const labels = section.querySelector('[data-lp-progress-labels]');
    const fill = section.querySelector('[data-lp-progress-fill]');
    const planLabel = section.querySelector('[data-lp-progress-plan]');
    const progressTotal = section.querySelector('[data-lp-progress-total]');
    const bagsChosen = section.querySelector('[data-lp-bags-chosen]');

    if (!progress) return;

    const shouldShowProgress =
      activePlan &&
      activePlan.type !== 'one-time';

    progress.hidden = !shouldShowProgress;

    if (!shouldShowProgress) {
      updateLpText(bagsChosen, '');
      updateLpText(progressTotal, '');
      return;
    }

    const minimum = activePlan.minimum;
    const progressQuantity = Math.min(selectedQuantity, minimum);
    const percentage = (progressQuantity / minimum) * 100;

    if (labels && labels.dataset.lpMinimum !== String(minimum)) {
      labels.innerHTML = Array.from(
        { length: minimum + 1 },
        (_, index) => `<span>${index}</span>`
      ).join('');

      labels.dataset.lpMinimum = String(minimum);
    }

    if (fill && fill.style.width !== `${percentage}%`) {
      fill.style.width = `${percentage}%`;
    }

    updateLpText(planLabel, activePlan.label);

    const chosenText =
      selectedQuantity <= minimum
        ? `${selectedQuantity}/${minimum} Bags chosen`
        : `${selectedQuantity} Bags chosen`;

    updateLpText(bagsChosen, chosenText);

    const orderTotal =
      selectedQuantity * activePlan.unitPrice;

    updateLpText(
      progressTotal,
      `TOTAL: $${orderTotal.toFixed(2)}`
    );
  }


  function syncAddToCartState(section, addToCartButton) {
    if (!addToCartButton) return;

    const selectedQuantity = getLpSelectedQuantity(section);
    const activePlan = getLpActivePlan(section);

    const requiredQuantity = activePlan?.minimum || 1;
    const isDisabled = selectedQuantity < requiredQuantity;

    addToCartButton.toggleAttribute('disabled', isDisabled);
    addToCartButton.classList.toggle('disabled', isDisabled);
    addToCartButton.setAttribute(
      'aria-disabled',
      isDisabled ? 'true' : 'false'
    );

    renderLpPlanProgress(section, activePlan, selectedQuantity);
  }


  function customizeSealSubscriptions(section) {
    const subscriptionOptions = Array.from(
      section.querySelectorAll(
        '.sls-option-container[data-selling-plan-group]'
      )
    );

    const oneTimeOption = section.querySelector(
      '.sls-option-container:not([data-selling-plan-group])'
    );

    subscriptionOptions.forEach((subscriptionOption) => {
      const planName =
        subscriptionOption
          .querySelector('.sls-selling-plan-group-name')
          ?.textContent
          ?.trim()
          ?.toLowerCase() || '';

      const is90DayPlan = planName.includes('90-day');
      const is30DayPlan = planName.includes('30-day');

      subscriptionOption.classList.toggle(
        'lp-buybox__plan--90-day',
        is90DayPlan
      );

      subscriptionOption.classList.toggle(
        'lp-buybox__plan--30-day',
        is30DayPlan
      );

      moveLpSubscriptionCheckbox(subscriptionOption);

      if (is90DayPlan) {
        syncLp90DayPlanCopy(subscriptionOption);
        syncLpPriceBelow(subscriptionOption, 90);
        syncLpPlanKit(section, subscriptionOption, '90-day');
      }

      if (is30DayPlan) {
        syncLp30DayPlanCopy(subscriptionOption);
        syncLpPriceBelow(subscriptionOption, 30);
        syncLpPlanKit(section, subscriptionOption, '30-day');
      }

      if (
        !is90DayPlan ||
        subscriptionOption.dataset.lpEnhanced === 'true'
      ) {
        return;
      }

      subscriptionOption
        .querySelectorAll(
          '.lp-buybox__popular-label, .lp-buybox__benefits'
        )
        .forEach((element) => element.remove());

      subscriptionOption.insertAdjacentHTML(
        'afterbegin',
        `
          <div class="lp-buybox__popular-label">
            Most Popular
          </div>
        `
      );

      const planOptions = subscriptionOption.querySelector(
        '.sls-selling-plan-group-options'
      );

      const benefitsMarkup = `
        <ul class="lp-buybox__benefits">
          <li>Complimentary Deluxe Welcome Kit.</li>
          <li>Easily change your quantities or flavors.</li>
          <li>Modify your delivery schedule or cancel any time.</li>
          <li>Free shipping.</li>
        </ul>
      `;

      if (planOptions) {
        planOptions.insertAdjacentHTML('afterend', benefitsMarkup);
      } else {
        subscriptionOption.insertAdjacentHTML('beforeend', benefitsMarkup);
      }

      subscriptionOption.dataset.lpEnhanced = 'true';
    });

    if (!oneTimeOption) {
      return;
    }

    oneTimeOption.classList.add('lp-buybox__plan--one-time');

    const oneTimePrice = oneTimeOption.querySelector('.sls-price');

    if (oneTimePrice && !oneTimePrice.querySelector('.sls-price-below')) {
      oneTimePrice.insertAdjacentHTML(
        'beforeend',
        '<div class="sls-price-below"></div>'
      );
    }

    syncLpPriceBelow(oneTimeOption, 30);

    if (oneTimeOption.dataset.lpEnhanced === 'true') {
      return;
    }

    oneTimeOption
      .querySelectorAll(
        '.lp-buybox__one-time-subtitle, .lp-buybox__one-time-note'
      )
      .forEach((element) => element.remove());

    oneTimeOption.dataset.lpEnhanced = 'true';
  }

  function syncLpPriceBelow(subscriptionOption, days) {
    const priceBelow = subscriptionOption.querySelector('.sls-price-below');

    if (!priceBelow) return;

    let nextText = '';

    const unitPrice = subscriptionOption
      .querySelector('[data-unit-price]')
      ?.dataset
      ?.unitPrice;

    if (unitPrice) {
      nextText = unitPrice.replace('/per day', '/day');
    } else {
      const billedLabel = subscriptionOption.querySelector(
        '.sls-selling-plan-group-options label'
      );

      if (!billedLabel) return;

      const price = parseFloat(
        billedLabel.textContent.replace(/[^0-9.]/g, '')
      );

      if (isNaN(price)) return;

      nextText = `$${(price / days).toFixed(2)}/day`;
    }

    if (priceBelow.textContent.trim() !== nextText) {
      priceBelow.textContent = nextText;
    }
  }

  function syncLp90DayPlanCopy(subscriptionOption) {
    if (
      subscriptionOption.dataset.lp90CopyEnhanced === 'true'
    ) {
      return;
    }

    const planName = subscriptionOption.querySelector(
      '.sls-selling-plan-group-name'
    );

    const price = subscriptionOption.querySelector(
      '.sls-total-price .sls-price'
    );

    if (!planName || !price) return;

    /*
      Set the guard before changing the DOM.
      The observer may run again after these mutations,
      but it will exit immediately.
    */
    subscriptionOption.dataset.lp90CopyEnhanced = 'true';

    if (!planName.querySelector('.lp-buybox__plan-choice')) {
      planName.insertAdjacentHTML(
        'beforeend',
        `
          <span class="lp-buybox__plan-choice">
            (choose 6 bags)
          </span>
        `
      );
    }

    Array.from(price.childNodes).forEach((node) => {
      if (
        node.nodeType === Node.TEXT_NODE &&
        node.textContent.trim()
      ) {
        node.remove();
      }
    });

    if (!price.querySelector('.lp-buybox__per-bag')) {
      price.insertAdjacentHTML(
        'beforeend',
        `
          <span class="lp-buybox__per-bag">
            per bag
          </span>
        `
      );
    }
  }

  function syncLp30DayPlanCopy(subscriptionOption) {
    if (
      subscriptionOption.dataset.lp30CopyEnhanced === 'true'
    ) {
      return;
    }

    const planName = subscriptionOption.querySelector(
      '.sls-selling-plan-group-name'
    );

    if (!planName) return;

    subscriptionOption.dataset.lp30CopyEnhanced = 'true';

    if (!planName.querySelector('.lp-buybox__plan-choice')) {
      planName.insertAdjacentHTML(
        'beforeend',
        `
          <span class="lp-buybox__plan-choice">
            (choose 2 bags)
          </span>
        `
      );
    }
  }


  function syncLpPlanKit(section, subscriptionOption, planType) {
    const enhancedAttribute = `data-lp-${planType}-kit-enhanced`;

    if (
      subscriptionOption.getAttribute(enhancedAttribute) === 'true'
    ) {
      return;
    }

    const template = section.querySelector(
      `[data-lp-plan-kit-template="${planType}"]`
    );

    if (!template) return;

    const kitMarkup = template.innerHTML.trim();

    if (!kitMarkup) return;

    subscriptionOption
      .querySelectorAll('.lp-buybox__plan-kit')
      .forEach((element) => element.remove());

    subscriptionOption.insertAdjacentHTML(
      'beforeend',
      kitMarkup
    );

    subscriptionOption.setAttribute(enhancedAttribute, 'true');
  }



  function moveLpSubscriptionCheckbox(subscriptionOption) {
    const radioColumn = subscriptionOption.querySelector(
      ':scope > .seal-row > .seal-col-radio'
    );

    const labelFirstLine = subscriptionOption.querySelector(
      ':scope > .seal-row > .sls-label-container > .sls-selling-plan-group-first-line'
    );

    if (!radioColumn || !labelFirstLine) return;

    const nativeRadioWrapper = radioColumn.querySelector(
      '.sls-selling-plan-group-first-line'
    );

    if (!nativeRadioWrapper) return;

    if (labelFirstLine.contains(nativeRadioWrapper)) return;

    labelFirstLine.prepend(nativeRadioWrapper);

    radioColumn.remove();
  }